import React from 'react';
import styled from 'styled-components';
import HeaderMenuLink from '../shared/headermenu/HeaderMenuLink';

//import citycadGreyLogo from "../../assets/images/icons/citycad-grey.png";

const ProjectTabContainer = styled.div`
  display: flex;
  align-items: center,
  justify-content: flex-start;
  padding: 5px 0px 5px 0px;
  cursor: pointer;
`;

class ProjectTabs extends React.Component {
  render() {
    const currentTab = this.props.currentTab;
    return (
      <ProjectTabContainer>
        <HeaderMenuLink active={currentTab === 'summary' ? "true" : "false"} to='#' onClick={() => {this.props.setCurrentTab('summary')}}>
          Resources
        </HeaderMenuLink>
        <HeaderMenuLink active={currentTab === 'details' ? "true" : "false"} to='#' onClick={() => {this.props.setCurrentTab('details')}}>
          Manage project
        </HeaderMenuLink>
        {/*<HeaderMenuLink active={currentTab === 'sites' ? "true" : "false"} to='#' onClick={() => {this.props.setCurrentTab('sites')}}>*/}
        {/*  Sites{this.props.projectData.SitesCount > 0 && ` (${this.props.projectData.SitesCount})`}*/}
        {/*</HeaderMenuLink>*/}

        {/*<HeaderMenuLink active={currentTab === 'filenotes' ? "true" : "false"} to='#' onClick={() => {this.props.setCurrentTab('filenotes')}}>*/}
        {/*  Project file notes{this.props.projectData.FileNotesCount > 0 && ` (${this.props.projectData.FileNotesCount})`}*/}
        {/*</HeaderMenuLink>*/}
      </ProjectTabContainer>
    )
  }
};

export default ProjectTabs;
